import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from "react-router-dom";
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import SvgIcon from '@material-ui/core/SvgIcon';
import CloseIcon from '@material-ui/icons/Close';
import Page from '../Page/Page';
import OstolaskuStatusIcon from '../Ostolaskut/OstolaskuStatusIcon';
import PercentIcon from '../../icons/percent.svg';
import utils, { currency, placeholderRows } from '../../utils';
import Attachments from '../Attachments/Attachments';
import InfoTile from '../InfoTile/InfoTile';
import VientiRivi from '../Receipt/VientiRivi';
import ConfirmButtons from './ConfirmButtons';
import Placeholder from '../Placeholder/Placeholder';
import RefreshButton from '../RefreshButton/RefreshButton';
import DatePicker from '../DatePicker';
import HyvitysChip from '../Ostolasku/HyvitysChip';

@inject('ostolaskuStore', 'viewStore')
@withRouter
@observer
class Ostolasku extends Component {
  componentDidMount() {
    this.props.ostolaskuStore.setCurrent(this.props.match.params.id, this.props.location.state);
  }

  render() {
    const { ostolaskuStore, viewStore } = this.props;
    const receipt = ostolaskuStore.receipt;


    return (
      <Page
        title={receipt.ORLASKUNUMERO ? 'Ostolasku #' + receipt.ORLASKUNUMERO : 'Ostolasku'}
        navigationAction={
          <IconButton
            onClick={ostolaskuStore.hideReceipt}
            color="inherit"
          >
            <CloseIcon />
          </IconButton>
        }
        actions={
          <div className="row">
            <IconButton
              color={viewStore.showVat ? 'inherit' : 'default'}
              onClick={viewStore.toggleVat}
            >
              <SvgIcon>
                <PercentIcon />
              </SvgIcon>
            </IconButton>

            <RefreshButton
              loading={ostolaskuStore.isLoading}
              onClick={ostolaskuStore.refresh}
            />
          </div>
        }
      >
        <div className="padding-md">
          <Typography component={'span'} variant="h5" className="text-center">
            <Placeholder size={8}>
              {receipt.TOIMITTAJANIMI}
            </Placeholder>
          </Typography>

          <div className="row margin-md-vert padding-sm" style={{ justifyContent: 'center', alignItems: 'center' }}>
            <OstolaskuStatusIcon data={receipt} />
            <Typography component={'span'} variant="body1" style={{ marginLeft: 8, opacity: .8 }}>
              <Placeholder size={8}>
                {(receipt.laskuvaihe)} {receipt.hyvitys && <HyvitysChip />}
              </Placeholder>
            </Typography>
          </div>

          <div className="row margin-md-vert" style={{ justifyContent: 'space-around' }}>
            <InfoTile title="Laskun päivä" value={utils.ymd2dmy(receipt.LASKUPVM)} />
            <InfoTile title="Eräpäivä" value={utils.ymd2dmy(receipt.ERAPVM)} />

            <InfoTile title="Maksuehdotus" value={

              <DatePicker
                value={receipt.MAKSUEHDOTUSPVM}
                onChange={ostolaskuStore.setMAKSUEHDOTUSPVM}
                format="dd.MM.yyyy"
                disablePast
                clearable
                style={{ width: 100 }}
                // Disabled when laskuvaihe is not "KESKEN" or when receipt.hyvitys === true
                disabled={!(receipt.laskuvaihe === 'KESKEN') || receipt.hyvitys}
              />
            } />
          </div>

          <div className="row margin-md-vert" style={{ justifyContent: 'space-around' }}>
            <InfoTile title="Veroton" value={currency(ostolaskuStore.taxfree)} />
            <InfoTile title="ALV" value={currency(ostolaskuStore.vat)} placeholderSize={3} />
            <InfoTile title="Summa" value={currency(receipt.LASKUNSUMMA)} />

          </div>

          <ConfirmButtons />
        </div>

        <div className="padding-md">
          <Typography component={'span'} variant="body1" style={{ opacity: .8, marginBottom: 8 }}>
            Tiliöinti
          </Typography>

          <table className="full-width">
            <thead>
              <tr>
                <td></td>
                <td className="cell-sum"></td>
                <td className="cell-sum"></td>
              </tr>
            </thead>
            {
              receipt.vientirivit ?
                receipt.vientirivit.map((row, idx) =>
                  <VientiRivi
                    key={idx}
                    data={row}
                    detailed={viewStore.showVat}
                  />
                ) :
                <tbody>
                  {
                    placeholderRows(6, 2).map((_, idx) =>
                      <tr key={idx}>
                        <td>
                          <Placeholder size={8} />
                        </td>
                        <td>
                          <Placeholder size={4} />
                        </td>
                        <td className="text-right">
                          <Placeholder size={4} />
                        </td>
                      </tr>
                    )
                  }
                </tbody>
            }
          </table>
        </div>

        {
          ((receipt.suoritukset && !!receipt.suoritukset.length) || receipt.laskuvaihe === 'VALMIS') &&
          <div className="padding-md">
            <Typography component={'span'} variant="body1" style={{ opacity: .8, marginBottom: 8 }}>
              Suoritukset
            </Typography>

            <table className="full-width">
              <thead>
                <tr>
                  <td></td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {
                  receipt.suoritukset ?
                    receipt.suoritukset.map((row, idx) =>
                      <tr key={idx}>
                        <td className="inforow-title">{utils.ymd2dmy(row.SUORITUSPVM)}</td>
                        <td className="text-right inforow-title">{currency(row.SUMMA)}</td>
                      </tr>
                    ) :
                    placeholderRows(2).map((_, idx) =>
                      <tr key={idx}>
                        <td>
                          <Placeholder size={4} />
                        </td>
                        <td className="text-right">
                          <Placeholder size={4} />
                        </td>
                      </tr>
                    )
                }
              </tbody>
            </table>
          </div>
        }

        {
          receipt.liitteet &&
          !!receipt.liitteet.length &&
          <div className="padding-md">
            <Typography component={'span'} variant="body1" style={{ opacity: .8, marginBottom: 8 }}>
              Liitteet
            </Typography>

            <Attachments
              attachments={receipt.liitteet}
              type="ostolaskut"
            />
          </div>
        }
      </Page>
    );
  }
}

export default Ostolasku;
